import OrgMembersListPage from './MembersListPage';
import _MemberImportPage from './MemberImportPage';

export const OrgMemberImportPage = _MemberImportPage;
export default OrgMembersListPage;
